import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var panel = /*#__PURE__*/css(["display:flex;background-color:var(--neutral-black-10);border-bottom:1px solid var(--neutral-black-30);"]);
export var buttonWrapper = /*#__PURE__*/css(["margin:", " auto;"], pxToRem(spacing.lg));
export var button = /*#__PURE__*/css(["display:block;"]);